import aaLogo from 'images/AAbyPO-FullColor-logo.svg';

export const DEFAULT_LOGO_URL = aaLogo;
export const DEFAULT_FAVICON_URL =
  'https://adadvance.s3.us-east-2.amazonaws.com/assets/adadvance.com/new_favicon.png';
export const DEFAULT_ICON_URL =
  'https://adadvance.s3.us-east-2.amazonaws.com/assets/adadvance.com/new_favicon.png';
export const DEFAULT_SMALL_LOGO_URL = aaLogo;
export const DEFAULT_SITE_TITLE = 'Streamline Dashboard';
export const COUNTRY_CODES = {
  U: 'US',
  C: 'CA',
  M: 'MX',
  Z: 'BR',

  B: 'UK',
  F: 'FR',
  S: 'ES',
  I: 'IT',
  L: 'BE',
  D: 'DE',
  E: 'AE',
  N: 'NL',
  P: 'PL',
  T: 'TR',
  W: 'SE',
  Y: 'IN',

  A: 'AU',
  J: 'JP',
  G: 'SG',
};
export const CURRENCY_CODES = {
  U: 'USD',
  C: 'USD',
  M: 'MXN',
  Z: 'BRL',

  B: 'GBP',
  F: 'EUR',
  S: 'EUR',
  I: 'EUR',
  D: 'EUR',
  L: 'EUR',
  E: 'AED',
  N: 'EUR',
  P: 'PLN',
  T: 'TRY',
  W: 'SEK',
  Y: 'INR',

  A: 'AUD',
  J: 'JPY',
  G: 'SGD',
};
export const MARKET_SSL_IMAGE_URL = {
  B: 'https://images-eu.ssl-images-amazon.com',
  E: 'https://images-eu.ssl-images-amazon.com',
  F: 'https://images-eu.ssl-images-amazon.com',
  S: 'https://images-eu.ssl-images-amazon.com',
  N: 'https://images-eu.ssl-images-amazon.com',
  I: 'https://images-eu.ssl-images-amazon.com',
  D: 'https://images-eu.ssl-images-amazon.com',
  U: 'https://images-na.ssl-images-amazon.com',
  C: 'https://images-na.ssl-images-amazon.com',
  M: 'https://images-na.ssl-images-amazon.com',
  Z: 'https://images-na.ssl-images-amazon.com',
  A: 'https://images-fe.ssl-images-amazon.com',
  J: 'https://images-fe.ssl-images-amazon.com',
  G: 'https://images-fe.ssl-images-amazon.com',
  L: 'https://images-eu.ssl-images-amazon.com',
  W: 'https://images-eu.ssl-images-amazon.com',
  P: 'https://images-eu.ssl-images-amazon.com',
  T: 'https://images-eu.ssl-images-amazon.com',
};

export const datePickerProps = {
  // autoFocus: false,
  // autoFocusEndDate: false,
  // initialStartDate: null,
  // initialEndDate: null,
  // presets: [],

  // input related props
  startDatePlaceholderText: 'Start Date',
  endDatePlaceholderText: 'End Date',
  disabled: false,
  required: false,
  screenReaderInputMessage: '',
  showClearDates: true,
  showDefaultInputIcon: false,
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,

  // calendar presentation and interaction related props
  renderMonthText: null,
  orientation: 'horizontal',
  anchorDirection: 'left',
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  initialVisibleMonth: null,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  isRTL: false,

  // navigation related props
  navPrev: null,
  navNext: null,

  // day presentation and interaction related props
  renderDayContents: null,
  minimumNights: 0,
  enableOutsideDays: false,
  isOutsideRange: (day) => false,

  // internationalization
  displayFormat: 'MMM D YYYY',
  monthFormat: 'MMMM YYYY',
};

export const singleDatePickerProps = {
  // input related props
  placeholder: 'Date',
  disabled: false,
  required: false,
  screenReaderInputMessage: '',
  showClearDate: false,
  showDefaultInputIcon: true,

  // calendar presentation and interaction related props
  renderMonthText: null,
  orientation: 'horizontal',
  anchorDirection: 'left',
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  initialVisibleMonth: null,
  numberOfMonths: 1,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDate: false,
  isRTL: false,

  // navigation related props
  navPrev: null,
  navNext: null,

  // day presentation and interaction related props
  renderDayContents: null,
  enableOutsideDays: false,
  isOutsideRange: (day) => false,

  // internationalization
  displayFormat: 'MMM D YYYY',
  monthFormat: 'MMMM YYYY',
};
export const COLOR_BLUE = '#0037FF';
export const COLOR_BLUE_LIGHT = '#27AAE1';
export const COLOR_GREY = '#989898';
export const COLOR_MAGENTA = '#EC008C';
export const COLOR_NAVY = '#242E3d';
export const COLOR_ORANGE = '#FF7F00';
export const COLOR_PURPLE = '#bf0066';
export const COLOR_PINK = '#ff5abc';
export const COLOR_RED = '#fd1b1b';
export const COLOR_RED_LIGHT = '#ff5c5c';
export const COLOR_WHITE = '#FFFFFF';

// IF changing these colors, need to also update in _custom.scss
export const PRIMARY = '#EC008C';
export const PRIMARY_2 = '#0037FF';
export const SECONDARY_1 = '#EC008C';
export const SECONDARY_2 = '#FF7F00';

export const ADDITIONAL_1 = '#FF7F00';
export const ADDITIONAL_2 = '#27AAE1';
export const ADDITIONAL_3 = '#ff5abc';
export const ADDITIONAL_4 = '#bf0066';
export const ADDITIONAL_5 = '#e83e00';
export const ADDITIONAL_6 = '#ffac5a';
